export enum SymptomControlRatingEnum {
  Asymptomatic = 0,
  WellControlled = 1,
  DifficultyControlled = 2,
  PoorlyControlled = 3,
  PoorlyControlledHosp = 4
}

export const SymptomControlRatingOptions = [
{ id: 0, label: '0 - Asymptomatic, no treatment needed at this time.' },
{ id: 1, label: '1 - Symptoms well controlled with current therapy.' },
{ id: 2, label: '2 - Symptoms controlled with difficulty, affecting daily functioning; patient needs ongoing monitoring.' },
{ id: 3, label: '3 - Symptoms poorly controlled; patient needs frequent adjustment in treatment and dose monitoring.' },
{ id: 4, label: '4 - Symptoms poorly controlled; history of rehospitalizations.' }
];
